export enum ModuleKey {
  PATIENT_MANAGEMENT = 'PATIENT_MANAGEMENT',
  APPOINTMENTS = 'APPOINTMENTS',
  MEDICAL_RECORDS = 'MEDICAL_RECORDS',
  LAB_ORDERS = 'LAB_ORDERS',
  // CPOE = 'CPOE',
  // PHARMACY = 'PHARMACY',
  // E_PRESCRIBING = 'E_PRESCRIBING',
  // ADT = 'ADT',
  // BED_MANAGEMENT = 'BED_MANAGEMENT',
  // CENSUS = 'CENSUS',
  IMAGING_ORDERS = 'IMAGING_ORDERS',
  BILLING = 'BILLING',
  CLINICAL_DECISION_SUPPORT = 'CLINICAL_DECISION_SUPPORT',
  TEMPLATES = 'TEMPLATES',
  VOICE_AI = 'VOICE_AI',
}

export interface ModuleFeature {
  key: string;
  name: string;
  description: string;
  enabled: boolean;
}

export interface ModuleToggle {
  key: ModuleKey;
  name: string;
  description: string;
  enabled: boolean;
  features: ModuleFeature[];
  dependsOn?: ModuleKey[]; // Modules this module depends on
}

export interface FeatureToggleState {
  modules: Record<ModuleKey, ModuleToggle>;
  lastUpdated: string;
  updatedBy?: string;
  /**
   * True once the clinic's real choices have arrived from the server.
   * Before that, `modules` is defaults-or-cache — fine to render from,
   * but not something to write back, or a user who reloads and
   * immediately saves would push defaults over their clinic's settings.
   */
  loaded: boolean;
  /** In-flight or failed write, for the admin screen to reflect. */
  saving: boolean;
  saveError: string | null;
}

export interface FeatureToggleActions {
  /** Pull the clinic's module choices from the server. Called on auth. */
  refresh: () => Promise<void>;
  /** Persist the current map to the clinic. Requires `system:write`. */
  save: () => Promise<void>;
  toggleModule: (moduleKey: ModuleKey, enabled: boolean) => void;
  toggleFeature: (moduleKey: ModuleKey, featureKey: string, enabled: boolean) => void;
  isModuleEnabled: (moduleKey: ModuleKey) => boolean;
  isFeatureEnabled: (moduleKey: ModuleKey, featureKey: string) => boolean;
  resetToDefaults: () => void;
  initializeDefaults: () => void;
  getDependentModules: (moduleKey: ModuleKey) => ModuleKey[];
  getMissingDependencies: (moduleKey: ModuleKey) => ModuleKey[];
  canDisableModule: (moduleKey: ModuleKey) => { canDisable: boolean; dependentModules: ModuleKey[] };
  canEnableModule: (moduleKey: ModuleKey) => { canEnable: boolean; missingDependencies: ModuleKey[] };
}

export type FeatureToggleStore = FeatureToggleState & FeatureToggleActions;
